// type FormatTypeValuesValue = {
//   value?: number
//   currency?: string
//   locale?: string
// }
// type FormatTypeValuesType = (string & {}) | "money" | "price_range"
// // type FormatTypeValuesArgs = {
// //   (
// //     value: FormatTypeValuesValue,
// //     type: FormatTypeValuesType,
// //   ): FormatTypeValuesValue
// //   (value: string, type: FormatTypeValuesType): string
// // }
// // export function formatTypeValues(
// //   value: FormatTypeValuesValue,
// //   type: FormatTypeValuesType,
// // ): FormatTypeValuesValue
// // export function formatTypeValues<T extends string>(
// //   value: T,
// //   type: FormatTypeValuesType,
// // ): T
// // export function formatTypeValues<T extends number | string>(
// //   value: FormatTypeValuesValue | T,
// //   type: FormatTypeValuesType,
// // ): FormatTypeValuesValue | T
// export function formatTypeValues<T extends FormatTypeValuesValue | string>(
//   value: FormatTypeValuesValue | T,
//   type: FormatTypeValuesType,
// ): FormatTypeValuesValue | string {
//   switch (type) {
//     case "money":
//     case "price_range":
//       if (typeof value === "string") {
//         return {
//           value: value,
//           currency: undefined,
//           locale: undefined,
//         }
//       }
//       return {
//         value: value?.value,
//         currency: value?.currency,
//         locale: value?.locale,
//       }
//     default:
//       return value
//   }
// }

// These types are dumb, but they used to be `any`...
export function formatTypeValues<T extends number | string, C>(
  value:
    | {
        value?: T
        currency?: C
        locale?: string
      }
    | string,
  type: (string & {}) | "money" | "price_range",
) {
  switch (type) {
    case "money":
    case "price_range":
      if (typeof value === "string") {
        return {
          value: value,
          currency: undefined,
          locale: undefined,
        }
      }
      return {
        value: value?.value,
        currency: value?.currency,
        locale: value?.locale,
      }
    default:
      return value
  }
}

export const roundToThreeDecimals = (value: number) => {
  return Math.round(value * 1000) / 1000
}

export const hexToRgb = (hex: string): string => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result
    ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}`
    : "0, 0, 0"
}

export const isValidDomain = (domain: string) => {
  const regex = new RegExp(
    /^([a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,}(:[0-9]{1,5})?(\/.*)?)$/,
  )
  return regex.test(domain)
}

//https://stackoverflow.com/questions/52869695/check-if-a-date-string-is-in-iso-and-utc-format
export const isIsoDate = (str: string) => {
  if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str)) return false
  const d = new Date(str)
  return !isNaN(d.getTime()) && d.toISOString() === str // valid date
}
